// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","cartUrgencyMessage":"cart-urgency_cartUrgencyMessage__797MF","clockIcon":"cart-urgency_clockIcon__pwbLI"};